
window.openIframePopup = function(src) {
	var $modal  = $('.popup-modal');
	var $iframe = $modal.find('iframe');

	src += src.indexOf('?') >= 0 ? '&' : '?';
	src += 'popup=1';

	$iframe.off('load').on('load', function() {
		var element = this;
		var count = 0;
        var targetHeight = 0;
		var interval = setInterval(function() {
			count++;

			if (count >= 4) {
				// een aantal keer de hoogte checken, om rekening te houden met vertraagd geladen content
				clearInterval(interval);
				return;
			}

			var height      = element.contentWindow.document.body.scrollHeight + 20;
			var maxHeight   = $(window).height() - 80;
			var hasOverflow = false;

			if (height > maxHeight) {
				height = maxHeight;
				hasOverflow = true;
			}

            if (height === targetHeight) {
                return;
            }

            targetHeight = height;

			$iframe.stop(true).animate({
				'height': height + 'px'
			}, 300, function() {
				$modal.removeClass('loading').toggleClass('has-overflow', hasOverflow);
				$iframe.removeClass('invisible');
				$iframe.contents().find('body').css({
					'height': '100%',
					'overflow': 'auto',
					'-webkit-overflow-scrolling': 'touch'
				});
			});
		}, 200);
	});

	$modal.modal('show');
	$modal.addClass('loading');
	$iframe.addClass('invisible').css({
		'height': '150px'
	}).attr('src', src);
}

window.showAlert = function(settings) {
	var modal = $('.alert-popin');
	var $btn  = modal.find('.btn');

	settings = $.extend({
		text:           '',
		textHeader:     modal.find('.yes').data('text-yes'),
		textButton:     modal.find('.yes').data('text-no'),
	}, settings);

	if (modal.is(':visible')) {
		return;
	}

	if (settings.textButton === undefined) {
		settings.textButton = 'OK';
	}

	modal.find('.modal-header h2').html(settings.textHeader);
	modal.find('.text').html(settings.text);
	$btn.text(settings.textButton);
	modal.modal({
		backdrop: 'static',
		keyboard: false
	}).modal('show');
}

window.showConfirm = function(settings) {
	var $popin = $('.confirm-popin');

	settings = $.extend({
		text:           '',
		textYes:        $popin.find('.yes').data('text-yes'),
		textNo:         $popin.find('.yes').data('text-no'),
		urlYes:         '#',
		onConfirm:      null,
		closeOnConfirm: true,
	}, settings);

	if ($popin.is(':visible')) {
		return;
	}

	var onClick = typeof(settings.onConfirm) === 'string' ? settings.onConfirm : '';

	$popin.find('.text').html(settings.text);
	$popin.find('.yes').off('click').attr('href', settings.urlYes).attr('onclick', onClick).text(settings.textYes);
	$popin.find('.no').text(settings.textNo);
	$popin.modal('show');

	$popin.find('.yes').on('click', (e) => {
		$popin.modal('hide');

		if (typeof(settings.onConfirm) === 'function') {
			settings.onConfirm(e, $popin, settings);
		}
	});
}

window.updateFileInputs = function() {
	$('.txtinput[type=file], .form-control[type=file]').each(function() {
		if ($(this).closest('.file-input').length > 0) {
			return;
		}

		$(this).wrap('<div class="file-input" />');

		var $parent = $(this).parent();

		$parent.append('<button type="button" class="btn"><i class="fa fa-file"></i> Choose file</button>');
		$parent.append('<input type="text" class="filename form-control" readonly>');

		$(this).on('change', function() {
			var file = $(this).get(0).files[0];
			$parent.find('.filename').val(file ? file.name : '');
		});
	});
}


window.htmlEncode = function(string) {
	string = $('<div>').text(string).html();
	string = string.replace('"', '&quot;');
	return string;
}


window.printOnly = function($element) {
    $('body').addClass('print-nothing');
    $element.addClass('print');
	$element.parents().addClass('print-parent');
    window.print();
    $element.removeClass('print');
	$element.parents().removeClass('print-parent');
    $('body').removeClass('print-nothing');
}


window.isScrolledIntoView = function($element) {
    if ($element.length === 0 || !$element.is(':visible')) {
    	return false;
	}

    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $element.offset().top;
    var elemBottom = elemTop + $element.height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}


window.openBackdrop = function(className, clickCallback) {
	if (typeof className == 'undefined') {
		className = 'backdrop';
	}

	var $backdrop = $('#main .' + className);

	if ($backdrop.length === 0) {
		$backdrop = $('<div class="' + className + '"></div>');
		$('#main').append($backdrop);
	}

	// if (!$backdrop.is(':visible')) {
		$backdrop.stop(true).fadeIn();
	// }

	if (typeof clickCallback == 'function') {
		$backdrop.on('click', clickCallback);
	}
}


window.closeBackdrop = function(className) {
	if (typeof className == 'undefined') {
		className = 'backdrop';
	}

	var $backdrop = $('#main .' + className);

	if ($backdrop.length > 0) {
		$backdrop.stop(true).fadeOut();
		$backdrop.on('click', function() {});
	}
}


window.smoothScrollTo = function($element, offset) {
    if ($element.length === 0) return;

	var scrollTop = $element.offset().top + (offset === undefined ? 0 : parseInt(offset));

	window.scrollTo({
		top: scrollTop,
		behavior: "smooth",
	});
}


window.smoothScrollToCenter = function($element, offset, duration) {
	if ($element.length === 0) return;

    offset -= $(window).height() / 2;
    smoothScrollTo($element, offset, duration);
}


window.getElementsInViewport = function(selector) {
	var elements = [];

	$(selector).each(function() {
		var rect = this.getBoundingClientRect();

		if (
			rect.bottom >= 0 &&
			rect.right >= 0 &&
			rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.left <= (window.innerWidth || document.documentElement.clientWidth)
		) {
			elements.push($(this));
		}
	});

	return elements;
}


window.checkDateInputs = function() {
    $('.input-group-date').each(function() {
		if ($(this).data('date-inputs')) {
			return;
		}

		var $group      = $(this);
		var $input      = $group.siblings('input')
        var $inputDay   = $group.find('.input-day');
        var $inputMonth = $group.find('.input-month');
        var $inputYear  = $group.find('.input-year');

		$input.attr('type', 'text').addClass('d-none');
		$group.removeClass('d-none');

		var inputFocus  = function($field) {
			$field.trigger('focus');
			$field.attr('type', 'text');
			$field.get(0).setSelectionRange($field.val().length, $field.val().length);
			$field.attr('type', 'number');
		};

		$(this).find('input[type=number]').on('keydown', function(e) {
			["e", "E", "+", "-", ".", ","].includes(e.key) && e.preventDefault();

		}).on('input init', function(e) {
			var value = parseInt($(this).val());
			var min = $(this).attr('min') || false;
			var max = $(this).attr('max') || false;

			if (min !== false && value < min) $(this).val(min);
			if (max !== false && value > max) $(this).val(max);

            var year  = $inputYear.val();
            var month = $inputMonth.val();
            var day   = $inputDay.val();

            if (month.length === 1) month = '0' + month;
            if (day.length === 1)   day   = '0' + day;

			var entered = year + '-' + month + '-' + day;
			if (entered === '--') entered = '';

			$input.val(entered).trigger(e.type);
		}).trigger('init');

		$group.on('focusout init', function(e) {
			if ($(e.relatedTarget).closest($group).length || e.relatedTarget === undefined) {
				// er is gefocused op een van de andere datumvelden, dan nog niet de datum valideren
				return;
			}

			if (e.type !== 'init') {
				$input.trigger('change');
			}
		}).trigger('init');

        $inputDay.on('keyup', function(e) {
			if ($(this).val().length === 2 && !isNaN(parseInt(e.key))) {
				inputFocus($inputMonth);
			}
		});

		$inputMonth.on('keyup', function(e) {
			if ($(this).val().length === 2 && !isNaN(parseInt(e.key))) {
				inputFocus($inputYear);
			}
		}).on('keydown', function(e) {
			if ($(this).val().length === 0 && e.keyCode === 8) {
				inputFocus($inputDay);
			}
		});

		$inputYear.on('keydown', function(e) {
			if ($(this).val().length === 0 && e.keyCode === 8) {
				inputFocus($inputMonth);
			}
		});

		$(this).data('date-inputs', true);
    });
}


window.GAhandleOutboundLinkClicks = function(outboundUrl) {
	if (typeof ga === 'function') {
		ga('send', 'event', {
			eventCategory: 'Outbound Link',
			eventAction: 'click',
			eventLabel: outboundUrl,
			transport: 'beacon'
		});
		ga('rollup.send', 'event', {
			eventCategory: 'Outbound Link',
			eventAction: 'click',
			eventLabel: outboundUrl,
			transport: 'beacon'
		});
	}
}
